<template>
  <v-card :flat="flat_card">
    <v-toolbar color="indigo" dense v-show="show_toolbar">
      <v-toolbar-title class="white--text"> Allegati </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <!-- Questo div è la zona azzurra che 
           fa da contorno al campo di input -->
      <div
        class="dropzone-container"
        @dragover="handleDragOver"
        @dragleave="handleDragLeave"
        @drop="handleDrop"
      >
        <!-- Campo di input dei file vero e proprio -->
        <input
          type="file"
          multiple
          name="file"
          id="fileInput"
          class="hidden-input"
          @change="handleChange($event)"
          ref="file"
          accept="*"
        />
        <!-- Etichetta del campo di input -->
        <label for="fileInput" class="file-label">
          <div v-if="is_dragging">Rilascia qui i documenti.</div>
          <div v-else>
            Rilascia qui i documenti o <u>clicca qui</u> per caricarli.
          </div>
        </label>

        <!-- Spazio dell'elenco degli allegati -->
        <div class="preview-container" v-if="items_files.length > 0">
          <!-- Card del singolo allegato -->
          <v-card
            :key="file.name"
            :style="{
              borderRadius: '0px',
              display: 'inline-block',
              marginRight: '20px',
              marginTop: '20px',
              maxWidth: max_tmb_dimension * 2 + 'px',
            }"
            v-for="file in items_files"
          >
            <!-- Fascetta superiore della card -->
            <v-toolbar color="indigo" dense height="20px">
              <v-spacer></v-spacer>
              <v-btn
                class="ml-2"
                icon
                small
                type="button"
                @click="remove(items_files.indexOf(file))"
              >
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <!-- Corpo interno della card -->
            <v-card-text>
              <!-- Miniatura per file formato immagine -->
              <img
                class="preview-img"
                :src="file.thumbnail"
                :width="file.width"
                :height="file.height"
                v-if="hasThumbnail(file.file.name)"
              />
              <!-- Icona per i file con formato strano -->
              <v-icon color="primary" :size="max_tmb_dimension" v-else>
                mdi-file-document
              </v-icon>
              <p>
                <b>{{ file.file.name }}</b>
                ({{ Math.round(file.file.size / 1000) + "kb" }})
              </p>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "DropFile",
  components: {
    SnackbarQV
  },
  props: {
    allegati: {
      type: Array(),
      default: () => [],
    },
    flat_card: {
      type: Boolean,
      default: false,
    },
    id_ref: {
      type: Number,
      default: -1,
    },
    max_tmb_dimension: {
      type: Number,
      default: 100,
    },
    show_toolbar: {
      type: Boolean,
      default: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      is_dragging: false,

      // Modal

      // Array
      items_files: [],
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible == true) {
          // Recupero gli allegati attuali dell'oggetto di riferimento.
          this.items_files = new Array();

          for (let f = 0; f < this.allegati.length; f++) {
            const obj_tmp = JSON.parse(JSON.stringify(this.allegati[f]));
            obj_tmp.file = this.allegati[f].file;
            this.items_files.push(obj_tmp);
          }
        }
      },
    },
  },
  methods: {
    generateThumbnail(file) {
      return new Promise((resolve) => {
        /* Genero una miniatura per il file appena caricato. */
        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function () {
          const img = document.createElement("img");
          img.src = reader.result;

          img.onload = function () {
            let width, height;
            let ratio = img.width / img.height;
            if (img.width > img.height) {
              width = Math.min(500, img.width);
              height = width / ratio;
            } else {
              height = Math.min(500, img.height);
              width = height * ratio;
            }
            let canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            const res = ctx.canvas.toDataURL();
            resolve(res);
          };
        };
      });
    },
    async generateThumbnailD(file, arg) {
      /* Genero una miniatura per il file appena caricato. */
      const img = document.createElement("img");
      let file_src = URL.createObjectURL(file);
      let res_h = 0;
      let res_w = 0;
      img.src = file_src;

      /* Specifico che quando ho in mano la src della miniatura,
       * voglio vederne larghezza e altezza. */
      const that = this;
      const res = await new Promise(function (resolve) {
        img.onload = function () {
          res_w = img.width;
          res_h = img.height;

          /* Revoco la URL per evitare possibili perdite
           * di memoria (leggo che si fa così).*/
          URL.revokeObjectURL(file_src);

          const res_tmp = new Object();

          if (arg === "H") {
            if (
              res_w > that.max_tmb_dimension ||
              res_h > that.max_tmb_dimension
            ) {
              // Se è larga o quadrata...
              if (res_w > res_h || res_w === res_h) {
                res_tmp.width = that.max_tmb_dimension;
                res_tmp.height = (res_tmp.width * res_h) / res_w;
                resolve(res_tmp.height);
              } else if (res_h > res_w) {
                // Se invece è alta...
                resolve(that.max_tmb_dimension);
              }
            } else {
              // Se l'immagine è più piccola della miniatura...
              resolve(res_h);
            }
          } else if (arg === "W") {
            // Se l'immagine eccede le dimensioni della miniatura...
            if (
              res_w > that.max_tmb_dimension ||
              res_h > that.max_tmb_dimension
            ) {
              // Se è larga o quadrata...
              if (res_w > res_h || res_w === res_h) {
                resolve(that.max_tmb_dimension);
              } else if (res_h > res_w) {
                // Se invece è alta...
                res_tmp.height = that.max_tmb_dimension;
                res_tmp.width = (res_tmp.heightz * res_w) / res_h;
                resolve(res_tmp.width);
              }
            } else {
              // Se l'immagine è più piccola della miniatura...
              resolve(res_w);
            }
          }
        };
      });
      return res;
    },
    getIdUtente() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getutenteattuale",
          token: localStorage.user_token,
        },
      };

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.id_utente = res.data.result.id_utente;
          } else {
            this.id_utente = -1;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile ottenere i dati."
            );
          }
        })
        .catch((e) => {
          this.id_utente = -1;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile ottenere i dati specificati"
          );
        });
    },
    async handleChange(e) {
      if (e) {
        e.preventDefault();
      }

      for (let f = 0; f < this.$refs.file.files.length; f++) {
        const obj_tmp = new Object();

        obj_tmp.file = this.$refs.file.files[f];
        //obj_tmp.name = this.$refs.file.files[f].name;
        obj_tmp.name = this.$refs.file.files[f].name;
        obj_tmp.guid_file = this.id_utente + "-" + moment().valueOf();
        /* Inspiegabilmente se si cambia l'ordine delle istruzioni
         * e si mette la thumbnail prima dei due await, la miniatura
         * risulta nulla a video anche se i dati sono presenti. Ho
         * provveduto a informare San Fausto di questo fatto durante
         * l'implementazione con dovizia di particolari, lamentandomi
         * per il tempo che mi ha fatto perdere. */
        if (this.hasThumbnail(this.$refs.file.files[f].name)) {
          obj_tmp.width = await this.generateThumbnailD(
            this.$refs.file.files[f],
            "W"
          );
          obj_tmp.height = await this.generateThumbnailD(
            this.$refs.file.files[f],
            "H"
          );
          obj_tmp.thumbnail = await this.generateThumbnail(
            this.$refs.file.files[f]
          );
        } else {
          obj_tmp.width = 0;
          obj_tmp.height = 0;
          obj_tmp.thumbnail = "";
        }

        this.$set(this.items_files, this.items_files.length, obj_tmp);
        //this.items_files.push(obj_tmp);
      }
    },
    handleDragLeave() {
      this.is_dragging = false;
    },
    handleDragOver(e) {
      e.preventDefault();
      this.is_dragging = true;
    },
    handleDrop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.handleChange();
      this.is_dragging = false;
    },
    hasThumbnail(arg_name) {
      const ext = arg_name.slice(-4);

      if (
        ext == ".jpg" ||
        ext == ".JPG" ||
        ext == ".png" ||
        ext == ".PNG" ||
        ext == "JPEG" ||
        ext == "jpeg"
      ) {
        return true;
      } else {
        return false;
      }
    },
    remove(i) {
      this.items_files.splice(i, 1);
    },
    getAttachments() {
      const res = new Array();

      for (let f = 0; f < this.items_files.length; f++) {
        const obj_tmp = JSON.parse(JSON.stringify(this.items_files[f]));
        obj_tmp.file = this.items_files[f].file;
        res.push(obj_tmp);
      }

      return res;
    },
  },
  created() {},
  mounted() {
    // this.getIdUtente();
  },
};
</script>
<style scoped>
.dropzone-container {
  padding-bottom: 50px;
  padding-top: 50px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
}

.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}

.file-label {
  font-size: 20px;
  display: block;
  cursor: pointer;
}

.preview-container {
  /*display: flex;*/
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.preview-card {
  display: flex;
  border: 1px solid #a2a2a2;
  padding: 5px;
  margin-left: 5px;
}

.preview-img {
  /*width: 50px;
  height: 50px;*/
  border-radius: 5px;
  border: 1px solid #a2a2a2;
  background-color: #a2a2a2;
}
</style>